/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Componente cellTemplate per la colorazione delle celle del calendario
 * in base agli orari lavorativi / turni.
 *
 * Viene invocato da Syncfusion per ogni cella "workCells" e "monthCells".
 * La logica di determinazione del colore è delegata alla funzione `getStatus`
 * passata dal calendario specifico (Default, User, Studio, Personal).
 *
 * Restituisce un div a piena dimensione con il backgroundColor appropriato,
 * oppure null se la cella è un orario lavorativo (usa la classe CSS nativa).
 */

export interface CellStatus {
  /** Codice stato: 0 = chiuso, 1 = turno, 2 = orario lavorativo */
  code: number;
  /** Colore CSS o classe (per code 2 senza multi-POS è la className nativa) */
  color: string;
}

interface WorkHoursCellTemplateProps {
  date: Date;
  type: string;
  groupIndex?: number;
  /** Funzione che calcola lo stato della cella */
  getStatus: (date: Date, type: string, groupIndex?: number) => CellStatus;
}

const cellStyle: React.CSSProperties = {
  position: 'absolute',
  inset: 0,
  pointerEvents: 'none',
  transition: 'filter 0.15s ease',
};

export function WorkHoursCellTemplate({
  date,
  type,
  groupIndex,
  getStatus,
}: WorkHoursCellTemplateProps): JSX.Element | null {
  if (type !== 'workCells' && type !== 'monthCells') return null;

  const { code, color } = getStatus(date, type, groupIndex);

  return (
    <div
      className="work-hours-cell-overlay"
      style={{ ...cellStyle, backgroundColor: color }}
    />
  );
}
